import * as THREE from "three";
import ExtrudedLoopSubGeometry2d from "../compoundSceneGeometry/ExtrudedLoopSubGeometry2d";
import AreaAnnotationData from "../sceneObjectData/AreaAnnotationData";
import { getSceneObjectStyle, getSceneObjectStyleName, SceneObjectStyle, SceneObjectStyleEnum } from "./SceneObjectStyle";

import { LineMaterial } from "three/addons/lines/LineMaterial.js";

export default class AreaAnnotationGeometry2d extends ExtrudedLoopSubGeometry2d<AreaAnnotationData> {

    private static lineMaterialCache = new WeakMap<SceneObjectStyle, LineMaterial>();
    private static fillMaterialCache = new WeakMap<SceneObjectStyle, THREE.MeshBasicMaterial>();
    private static textMaterialCache = new WeakMap<SceneObjectStyle, THREE.MeshBasicMaterial>();

    private static getLineMaterial(style: SceneObjectStyle): LineMaterial {
        let mat = AreaAnnotationGeometry2d.lineMaterialCache.get(style);
        if (!mat) {
            mat = new LineMaterial({
                color: style.color,
                linewidth: style.lineWidth,
                resolution: new THREE.Vector2(window.innerWidth, window.innerHeight),
                depthTest: false
            });
            mat.name = `AreaAnnotation2d-${getSceneObjectStyleName(style)}-Line`;
            AreaAnnotationGeometry2d.lineMaterialCache.set(style, mat);
        }
        return mat;
    }

    private static getFillMaterial(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        let mat = AreaAnnotationGeometry2d.fillMaterialCache.get(style);
        if (!mat) {
            mat = new THREE.MeshBasicMaterial({ color: style.color, transparent: true, opacity: 0.35, depthTest: false, side: THREE.DoubleSide });
            mat.name = `AreaAnnotation2d-${getSceneObjectStyleName(style)}-Fill`;
            AreaAnnotationGeometry2d.fillMaterialCache.set(style, mat);
        }
        return mat;
    }

    private static getTextMaterial(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        let mat = AreaAnnotationGeometry2d.textMaterialCache.get(style);
        if (!mat) {
            mat = new THREE.MeshBasicMaterial({ color: style.color });
            mat.name = `AreaAnnotation2d-${getSceneObjectStyleName(style)}-Text`;
            AreaAnnotationGeometry2d.textMaterialCache.set(style, mat);
        }
        return mat;
    }

    constructor() {
        super(
            AreaAnnotationGeometry2d.getLineMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal)),
            AreaAnnotationGeometry2d.getFillMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal)),
            AreaAnnotationGeometry2d.getTextMaterial(getSceneObjectStyle(SceneObjectStyleEnum.Normal))
        );
    }

    protected getLineMaterialForStyle(style: SceneObjectStyle): LineMaterial {
        return AreaAnnotationGeometry2d.getLineMaterial(style);
    }

    protected getFillMaterialForStyle(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        return AreaAnnotationGeometry2d.getFillMaterial(style);
    }

    protected getTextMaterialForStyle(style: SceneObjectStyle): THREE.MeshBasicMaterial {
        return AreaAnnotationGeometry2d.getTextMaterial(style);
    }
}
